import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { __, mapStateToProps } from '../../core/utils';
import { subscribe } from 'react-contextual';
import Localization from '../../helpers/Localization';
import Input from '../../components/Input';
import Textarea from '../../components/Textarea';
import Checkbox from '../../components/Checkbox';
import Button from '../../components/Button';
import ButtonGroup from '../../components/ButtonGroup';
import styles from '../../styles/forms/planning_template/PlanningTemplateForm.scss';

@reduxForm({
  form: 'planning_template',
  enableReinitialize: true,
})
@subscribe(Localization, 'localization')
@mapStateToProps((state) => ({
  application_language_id: state.auth.language_id,
}))
class PlanningTemplateForm extends Component {
  render() {
    const applicationLanguages = _.transform(
      _.filter(
        this.props.localization.languages,
        (language) => language.application_language == true
      ),
      (languages, language) => {
        languages[language.id] =
          language.id == this.props.application_language_id;

        return languages;
      },
      {}
    );

    return (
      <Form className={styles.wrapper} onSubmit={this.props.handleSubmit}>
        <div className={styles.form}>
          <Field
            name='name'
            component={Input}
            localized={applicationLanguages}
            label={__('planning-templates.editor.name')}
          />
          <Field
            name='description'
            component={Textarea}
            localized={applicationLanguages}
            label={__('planning-templates.editor.description')}
            rows={3}
            maxRows={4}
          />
          <Field
            name='active'
            component={Checkbox}
            blue
            label={__('planning-templates.editor.active')}
          />
        </div>

        <footer className={styles.footer}>
          <Button
            lightGray
            medium
            middleText={__('button.cancel')}
            onClick={this.props.onClose}
          />
          <ButtonGroup>
            <Button
              submit
              lightBlue
              medium
              middleText={__('button.save')}
              spinning={this.props.submitting}
            />
          </ButtonGroup>
        </footer>
      </Form>
    );
  }
}

export default PlanningTemplateForm;
